import React from 'react'
import styled from 'styled-components'

import { TimeAgo, TableComponents, HighlightedText } from '@sketch/components'
import { ReactComponent as FolderIcon } from '@sketch/icons/folder-closed-17'

import {
  ImageWrapper,
  TableWrapper,
  Name,
  TableCell,
  NameWrapper,
  SelectedCheckboxWrapper,
  SelectedCheckbox,
} from '../DocumentItem/DocumentItem.styles'
import { ProjectItemProps, getButtonProps, renderDropdown } from './utils'
import { handleTimeFormat } from '../DocumentItem'
import { StyledStatusIcon } from './ProjectItem.styles'
import { useSearch } from '@sketch/utils'
import { useFlag } from '@sketch/modules-common'

export const ProjectItemListView = styled(function ProjectItemListView(
  props: OmitSafe<ProjectItemProps, 'showSelectionCheckbox'>
) {
  const {
    className,
    name,
    deletedAt,
    renderDropdownItems,
    onClick,
    childrenItemCount,
    archivedAt,
    totalCollections,
    selected,
    onSelectChange,
    identifier,
  } = props

  const isMultipleSelectionOn = useFlag('multiple-selection')
  const { search } = useSearch()
  const dropdownContent = renderDropdownItems?.()
  const a11yProps = onClick ? getButtonProps(onClick) : {}
  const archivedDate = archivedAt
    ? new Date(archivedAt).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    : '-'

  return (
    <TableWrapper
      className={className}
      title={name}
      data-project-id={identifier}
      $isSelected={selected}
      {...a11yProps}
    >
      <TableCell>
        <NameWrapper>
          {isMultipleSelectionOn && (
            <SelectedCheckboxWrapper onClick={event => event.stopPropagation()}>
              <span className="sr-only">
                {selected ? 'Unselect project' : 'Select project'}
              </span>
              <SelectedCheckbox
                type="checkbox"
                checked={selected}
                onChange={event => onSelectChange?.(event.target.checked)}
              />
            </SelectedCheckboxWrapper>
          )}
          <ImageWrapper title={name} data-drag-image>
            <StyledStatusIcon as={FolderIcon} aria-label={`Folder ${name}`} />
          </ImageWrapper>
          <Name>
            <HighlightedText search={search}>{name}</HighlightedText>
          </Name>
        </NameWrapper>
      </TableCell>
      <TableCell>{totalCollections}</TableCell>
      <TableCell>
        <div className="keep-size">
          {deletedAt ? (
            <TimeAgo date={deletedAt} formatter={handleTimeFormat} />
          ) : (
            <>{childrenItemCount}</>
          )}
        </div>
      </TableCell>
      <TableCell>{archivedDate}</TableCell>
      {dropdownContent && (
        <TableComponents.TableCellSticky>
          {renderDropdown(dropdownContent, props.deletedAt)}
        </TableComponents.TableCellSticky>
      )}
    </TableWrapper>
  )
})``
